import React, { useState, useEffect } from 'react'
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { useDispatch, useSelector } from 'react-redux';
import { learningTrackListRes, learningTrackListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearningTrackList';
import {  FaEdit } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import TrackDetails from './TrackDetails';
import { trackDetailsRes, trackDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/TrackDetails';

export default function LearningTrackList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.learningTrackList && state.learningTrackList.data && state.learningTrackList.data.data)
    const [loading, setLoading] = useState(false)
    const [detailModal, setDetailModal] = useState(false)
    const [modalLoading, setModalLoading] = useState(true)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'TITLE',
            field: 'learning_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESCRIPTION',
            field: 'description',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline  size={20} className='eye'
                        onClick={() => track_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Track Details!"
                        data-tooltip-place="bottom"
                    />
                    {params.data.isEditable ?
                        <FaEdit size={20} className='edit ms-3'
                            onClick={() => edit_track(params)}
                            data-tooltip-id='edit'
                            data-tooltip-content="Edit Track!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const edit_track = (params) => {
        navigate('/add_learning_track', { state: params.data })
    }

    const track_details = (params) => {
        setModalLoading(true)
        setDetailModal(true)
        dispatch(trackDetailsTodo(params.data.id)).then(() => track_details_res())
    }

    const track_details_res = () => {
        if (trackDetailsRes && trackDetailsRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    const learning_track_res = () => {
        if (learningTrackListRes && learningTrackListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(learningTrackListTodo({"temp": "list"})).then(() => learning_track_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <span className='icon2'>Learning Track</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    < DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }

            </div>

            <TrackDetails detailModal={detailModal} setDetailModal={setDetailModal} modalLoading={modalLoading} setModalLoading={setModalLoading} />
        </>
    )
}
